import React from "react";
import "./BasketManagement.css";
import BasketBuilder from "../BasketBuilder/BasketBuilder";
import UserBasketList from "../UserBasketList/UserBasketList";
import { Row, Container } from "react-bootstrap";
import { useAuth } from "../../Auth/useAuth";

function BasketManagement() {
  const [auth] = useAuth();
  const clientProfile = auth && auth?.user && auth.user.client_profile;
  const [isCartCreating, setCartCreationProcessing] = React.useState(false);
  return (
    <React.Fragment>
      <Container fluid className="baskets-container">
        <Row className="baskets-component">
          {clientProfile?.id && (
            <BasketBuilder isCartCreating={setCartCreationProcessing} disabled={isCartCreating} />
          )}
          <UserBasketList disabledBtn={isCartCreating} />
        </Row>
      </Container>
    </React.Fragment>
  );
}

export default BasketManagement;
